module.exports = __webpack_public_path__ + "img/LogoLow.fca561b0.png";